/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimVisualReferenceVisualReference } from './TimVisualReferenceVisualReference';
import {
    TimVisualReferenceVisualReferenceFromJSON,
    TimVisualReferenceVisualReferenceFromJSONTyped,
    TimVisualReferenceVisualReferenceToJSON,
} from './TimVisualReferenceVisualReference';

/**
 * 
 * @export
 * @interface TimVisualReference
 */
export interface TimVisualReference {
    /**
     * 
     * @type {string}
     * @memberof TimVisualReference
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TimVisualReference
     */
    date: string;
    /**
     * 
     * @type {string}
     * @memberof TimVisualReference
     */
    citation: string;
    /**
     * 
     * @type {TimVisualReferenceVisualReference}
     * @memberof TimVisualReference
     */
    visual_reference: TimVisualReferenceVisualReference;
}

/**
 * Check if a given object implements the TimVisualReference interface.
 */
export function instanceOfTimVisualReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "date" in value;
    isInstance = isInstance && "citation" in value;
    isInstance = isInstance && "visual_reference" in value;

    return isInstance;
}

export function TimVisualReferenceFromJSON(json: any): TimVisualReference {
    return TimVisualReferenceFromJSONTyped(json, false);
}

export function TimVisualReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimVisualReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': json['date'],
        'citation': json['citation'],
        'visual_reference': TimVisualReferenceVisualReferenceFromJSON(json['visual_reference']),
    };
}

export function TimVisualReferenceToJSON(value?: TimVisualReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': value.date,
        'citation': value.citation,
        'visual_reference': TimVisualReferenceVisualReferenceToJSON(value.visual_reference),
    };
}

